import { FC, useCallback, useContext } from 'react';

import { H3, Separator } from '@smartshell/ui-kit';

import { ColorPicker, SettingsFrame } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';

import s from './CurrentColors.module.scss';
import { ICurrentColors } from './interfaces';

export const CurrentColors: FC<ICurrentColors> = ({
  additionalColor,
  accentColor,
  setState,
}) => {
  const { t } = useContext(LocalizationContext);

  const setAdditionalColor = useCallback(
    (color) => {
      setState((prev) => ({ ...prev, shellSkinAdditionalColor: color }));
    },
    [additionalColor]
  );

  const setAccentColor = useCallback(
    (color) => {
      setState((prev) => ({ ...prev, shellSkinAccentColor: color }));
    },
    [additionalColor]
  );

  const isAvailable = useIsFeatureAvailable('shell_skin');

  return (
    <SettingsFrame>
      <div className={s.container}>
        <div className={s.header}>
          <H3>{t('settings.shell.customization.colors.title')}</H3>
          <span className={s.subtitle}>
            {t('settings.shell.customization.colors.description')}
          </span>
        </div>

        <Separator />
        <div className={s.header}>
          <H3>{t('settings.shell.customization.accentColor.title')}</H3>
          <span className={s.subtitle}>
            {t('settings.shell.customization.accentColor.description')}
          </span>
        </div>
        <ColorPicker
          color={accentColor}
          setColor={setAccentColor}
          disabled={!isAvailable}
        />

        <Separator />
        <div className={s.header}>
          <H3>{t('settings.shell.customization.additionalColor.title')}</H3>
          <span className={s.subtitle}>
            {t('settings.shell.customization.additionalColor.description')}
          </span>
        </div>
        <ColorPicker
          color={additionalColor}
          setColor={setAdditionalColor}
          disabled={!isAvailable}
        />
      </div>
    </SettingsFrame>
  );
};
